import type { Infer } from 'superstruct';
import { pick } from 'superstruct';

import { AddMediaDto } from './add-media.dto';

export const EditMediaDto = pick(AddMediaDto, ['name']);

export type EditMediaDto = Infer<typeof EditMediaDto>;
